<footer class="main-footer">
  <div class="pull-right hidden-xs">
    <b>Version</b> 1.0.0
  </div>
  <strong>Copyright © 2014-2016 <a href="http://www.inocon.com.br">Inocon - Inovação em Controles Web</a>.</strong>
  Todos os direitos reservados.
</footer>